import styled from 'styled-components';
export const ErrorMessageWrapper = styled.div `
  height: 2rem;
`;
export const DisclaimerContainer = styled.div `
  margin: 2rem 0;
`;
export const CheckboxContainer = styled.div `
  margin: 2.3rem 0 3.3rem;
`;
//# sourceMappingURL=styles.js.map